var React = require('react');

function SliderLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"slider_left","transform":"translate(-349 -2293)"},[React.createElement("g",{"id":"Ellipse_1","data-name":"Ellipse 1","transform":"translate(349 2293)","fill":"#fff","stroke":"#f8f7f7","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"28","cy":"28","r":"28","stroke":"none","key":0}),React.createElement("circle",{"cx":"28","cy":"28","r":"27","fill":"none","key":1})]),React.createElement("path",{"id":"Path_1088","data-name":"Path 1088","d":"M537.742,2812.064l-4.834-4.834,4.834-4.834","transform":"translate(-158.325 -486.23)","fill":"none","stroke":"#628942","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

SliderLeft.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56"};

module.exports = SliderLeft;

SliderLeft.default = SliderLeft;
